<template>
    <BasePage box-shadow :model="basePage">
        <div class="order-review">
            <h3 v-if="model.isDonation">Donation Confirmation</h3>
            <h3 v-else>Tree registration confirmation</h3>
            <div class="flex-view-col">
                <h3>Customer Details</h3>
                <div class="grid-view">
                    <div>Name</div>
                    <div>{{ model.customer.title }} {{ model.customer.firstName }}</div>
                    <div>Last Name</div>
                    <div>{{ model.customer.lastName }}</div>
                    <div>Phone</div>
                    <div>{{ model.customer.phone }}</div>
                    <div>Email</div>
                    <div>{{ model.customer.email }}</div>
                </div>
            </div>
            <div class="flex-view-col">
                <h3>Registration Details</h3>
                <div class="registration-grid-view">
                    <div>Name</div>
                    <div v-if="!model.isDonation">Quantity</div>
                    <div>Price</div>
                </div>
                <div class="registration-grid-view" v-for="order in model.orderLines">
                    <div>{{ order.name }}</div>
                    <div v-if="!model.isDonation">{{ order.quantity }}</div>
                    <div>£{{ order.totalPrice }}</div>
                </div>
            </div>
            <h3>Total: £{{ model.totalPrice }}</h3>

            <Button type="submit" class="button-payment">Continue to payment</Button>
        </div>
    </BasePage>
</template>
<script lang="ts" setup>
import BasePage from '@/components/Common/BasePage/BasePage.vue';
import { IHeroSection } from '@/models/model';
import { Button } from '@/components/ui/button';
import { IOrderReviewProps } from './OrderReview.model';

const { model } = defineProps<IOrderReviewProps>()


const basePage: IHeroSection = {
    title: "Review your Order"
}
</script>
<style lang="scss" scoped>
.order-review {
    display: flex;
    flex-direction: column;
    font-size: 1.15rem;
    padding: 24px 30px;
    border-radius: 0 0 24px 24px;
    border: 1px solid lightgray;
    border-top: 0;
    gap: 15px;
}

.grid-view {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;

    div:nth-of-type(odd) {
        font-weight: 600;
    }
}

.registration-grid-view {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    align-items: center;
}

h3 {
    font-weight: 700;
    font-size: 1.75rem;
}

.flex-view-col {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.button-payment {
    align-self: flex-end;
    max-width: fit-content;
    margin-top: 20px;
}

@media (min-width: 768px) {
    .grid-view {
        grid-template-columns: max-content 1fr;
    }
}
</style>